import { Slide } from '@fiverr-private/carousel';

export default Slide;
